/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

/** @description import Global or some other files only if you need them */

'use strict';
const PartnerSlider = {
	init: function() {
		this.PartnerSlider();
	},

	PartnerSlider: function() {
		$('.js-partners-slider').slick({
			slidesToShow: 3,
			slidesToScroll: 3,
			arrows: false,
			dots: true,
			adaptiveHeight: true,
			infinite: true,
			speed: 300,
			fade: false,
			autoplay: true,
			autoplaySpeed: 5000,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});
	},

};

export default PartnerSlider;
